import { Component } from 'react';
import VizExImage from 'visitor-ui-component-library/image/VizExImage';
import { jsx as _jsx } from "react/jsx-runtime";
class ImageAttachmentPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageDataUrl: ''
    };
  }
  componentDidMount() {
    this.processImageFile(this.props.imageFile);
  }
  componentDidUpdate(prevProps) {
    if (this.props.imageFile !== prevProps.imageFile) {
      this.processImageFile(this.props.imageFile);
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return nextState.imageDataUrl !== this.state.imageDataUrl;
  }
  processImageFile(imageFile) {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      this.setState({
        imageDataUrl: reader.result
      });
    });
    reader.readAsDataURL(imageFile);
  }
  render() {
    return /*#__PURE__*/_jsx(VizExImage, {
      src: this.state.imageDataUrl
    });
  }
}
ImageAttachmentPreview.displayName = 'ImageAttachmentPreview';
export default ImageAttachmentPreview;